import type { ExtractedDraft } from "../schema";

interface Props {
  draft: ExtractedDraft;
  sourceFileName: string;
  onUse: () => void;
  onEdit: () => void;
  onDiscard: () => void;
}

export function DraftBanner({ draft, sourceFileName, onUse, onEdit, onDiscard }: Props) {
  return (
    <aside className="draft-banner" role="note" aria-label="Draft suggestion">
      <span className="draft-banner__glyph" aria-hidden>¶</span>

      <div className="draft-banner__body">
        <div className="draft-banner__attr mono">
          <span className="draft-banner__attr-label">Draft from</span>{" "}
          <span className="draft-banner__attr-file">{sourceFileName}</span>
          <span className="draft-banner__attr-sep">·</span>
          <span className="draft-banner__attr-conf">
            {draft.confidence} confidence
          </span>
        </div>

        {draft.sourceQuote && (
          <blockquote className="draft-banner__quote" title={draft.sourceQuote}>
            "{draft.sourceQuote}"
          </blockquote>
        )}
      </div>

      <div className="draft-banner__actions">
        <button
          type="button"
          className="btn btn--text draft-banner__act draft-banner__act--use"
          onClick={onUse}
        >
          Use draft
        </button>
        <button
          type="button"
          className="btn btn--text draft-banner__act"
          onClick={onEdit}
        >
          Edit
        </button>
        <button
          type="button"
          className="btn btn--text btn--danger draft-banner__act"
          onClick={onDiscard}
        >
          Discard
        </button>
      </div>
    </aside>
  );
}

export default DraftBanner;
